import { Injectable } from "@angular/core";
import { LocalStorageService } from "src/app/utils/localstorage.service";
import Pusher from "pusher-js";
import { Subject } from "rxjs";
import { environment } from "src/environments/environment";
import { SharedDataService } from "src/app/dashboard/shared-data.service";

@Injectable({ providedIn: "root" })
export class RealTimeService {
  public pusher: Pusher;

  private bellNotificationsChannel: any;
  bellNotifications = new Subject();

  private jobNotificationsChannel: any;
  jobCommentNotifications = new Subject();

  public trackedItemCommentsChannel: any;
  trackedItemComments = new Subject();

  private conversationUpdatesChannel: any;
  conversationUpdates$ = new Subject();

  private huddleActivityChannel: any;
  huddleActivity = new Subject();

  newTrackedItem = new Subject();

  notificationsLoadedSubject = new Subject();

  constructor(
    private localStorage: LocalStorageService,
    private sharedDataService: SharedDataService,
  ) {
    this.pusher = new Pusher(environment.pusherConfig.pusherAppKey, {
      cluster: environment.pusherConfig.pusherAppCluster,
    });

    const dataUuid = this.sharedDataService.data.uuid;
    this.bellNotificationsChannel = this.pusher.subscribe(`user.${dataUuid}`);
    this.bellNotificationsChannel.bind("new-notification", (msg: any) => {
      this.bellNotifications.next(msg);
    });
  }

  setJobNotificationsListener(jobUuid: string) {
    this.jobNotificationsChannel = this.pusher.subscribe(`job.${jobUuid}`);
    this.jobNotificationsChannel.bind("job-comment", (msg: any) => {
      this.jobCommentNotifications.next(msg);
    });
  }
  unsetJobNotificationsListener() {
    this.jobNotificationsChannel = null;
  }

  setTrackedItemCommentsListener(trackedItemUuid: string) {
    this.trackedItemCommentsChannel = this.pusher.subscribe(
      `tracked-item.${trackedItemUuid}`,
    );
    this.trackedItemCommentsChannel.bind("new-notification", (msg: any) => {
      this.trackedItemComments.next(msg);
    });
  }
  unsetTrackedItemCommentsListener() {
    this.trackedItemCommentsChannel = null;
  }

  setConversationUpdatesListener(conversationUuid: string) {
    if (this.conversationUpdatesChannel != null) {
      this.conversationUpdatesChannel.unbind();
      this.pusher.unsubscribe(this.conversationUpdatesChannel.name);
      this.conversationUpdatesChannel = null;
    }

    this.conversationUpdatesChannel = this.pusher.subscribe(
      `conversation-updates.${conversationUuid}`,
    );
    this.conversationUpdatesChannel.bind("tracked-item-update", (msg: any) => {
      this.conversationUpdates$.next(msg);
    });

    this.conversationUpdatesChannel.bind("new-tracked-item", (msg: any) => {
      this.newTrackedItem.next(msg);
    });

    this.conversationUpdatesChannel.bind("tracked-item-delete", (msg: any) => {
      this.conversationUpdates$.next(msg);
    });
  }

  setHuddleActivityListener(channel: string) {
    this.huddleActivityChannel = this.pusher.subscribe(`channel.${channel}`);
    this.huddleActivityChannel.bind(
      "channel-activity",
      (msg: { active: boolean; status: string }) => {
        this.huddleActivity.next(msg);
      },
    );
  }
  unsetHuddleActivityListener() {
    this.huddleActivityChannel = null;
  }
}
